/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Timeline_Event_Aria_LabelInputs */

const en_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timeline event from ${i?.start} to ${i?.end}`)
};

const fr_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evenement de la chronologie de ${i?.start} a ${i?.end}`)
};

const de_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zeitachsenereignis von ${i?.start} bis ${i?.end}`)
};

const it_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento della cronologia da ${i?.start} a ${i?.end}`)
};

const ru_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Хронология событий от ${i?.start} до ${i?.end}`)
};

const es_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento de la línea de tiempo de ${i?.start} a ${i?.end}`)
};

const zh_cn2_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`从${i?.start}到${i?.end}的时间线事件`)
};

const ja_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start} から ${i?.end} までのタイムラインイベント`)
};

const hi_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start} से ${i?.end} तक की समयरेखा घटना`)
};

const pt_pt2_timeline_event_aria_label = /** @type {(inputs: Timeline_Event_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento da linha do tempo de ${i?.start} a ${i?.end}`)
};

/**
* | output |
* | --- |
* | "Timeline event from {start} to {end}" |
*
* @param {Timeline_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_event_aria_label = /** @type {((inputs: Timeline_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_event_aria_label(inputs)
	if (locale === "de") return de_timeline_event_aria_label(inputs)
	if (locale === "it") return it_timeline_event_aria_label(inputs)
	if (locale === "ru") return ru_timeline_event_aria_label(inputs)
	if (locale === "es") return es_timeline_event_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_event_aria_label(inputs)
	if (locale === "ja") return ja_timeline_event_aria_label(inputs)
	if (locale === "hi") return hi_timeline_event_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_event_aria_label(inputs)
	return en_timeline_event_aria_label(inputs)
});